var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitRiderIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 43,
    viewBox: "0 0 48 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_13660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1641 41.7011C13.1641 35.69 18.0351 30.811 24.0541 30.811C30.0652 30.811 34.9441 35.6821 34.9441 41.7011H13.172H13.1641Z",
    stroke: "#187C85",
    strokeWidth: 1.25997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0573 30.8197C27.5224 30.8197 30.3315 28.0107 30.3315 24.5456C30.3315 21.0805 27.5224 18.2715 24.0573 18.2715C20.5922 18.2715 17.7832 21.0805 17.7832 24.5456C17.7832 28.0107 20.5922 30.8197 24.0573 30.8197Z",
    stroke: "#187C85",
    strokeWidth: 1.25997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8047 17.0192C17.9492 15.1218 20.7634 13.9658 23.8486 13.9658C26.918 13.9658 29.7242 15.1058 31.8607 16.9873",
    stroke: "#187C85",
    strokeWidth: 1.25997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0753 13.5654C29.3482 12.3365 31.0051 8.68714 29.7762 5.41432C28.5474 2.14149 24.898 0.48454 21.6252 1.71341C18.3524 2.94228 16.6954 6.59163 17.9243 9.86445C19.1532 13.1373 22.8025 14.7942 26.0753 13.5654Z",
    stroke: "#187C85",
    strokeWidth: 1.25997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7148 31.0344C33.3173 29.5835 35.4458 28.7065 37.7737 28.7065C42.7723 28.7065 46.8222 32.7564 46.8222 37.755H36.8091",
    stroke: "#187C85",
    strokeWidth: 1.25997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9882 23.4848C42.9882 26.3628 40.6523 28.6986 37.7744 28.6986C34.8964 28.6986 32.5605 26.3628 32.5605 23.4848C32.5605 20.6069 34.8964 18.271 37.7744 18.271C40.6523 18.271 42.9882 20.6069 42.9882 23.4848Z",
    stroke: "#187C85",
    strokeWidth: 1.25997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2987 31.0344C14.6963 29.5835 12.5678 28.7065 10.2399 28.7065C5.24129 28.7065 1.19141 32.7564 1.19141 37.755H11.2045",
    stroke: "#187C85",
    strokeWidth: 1.25997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01562 23.4848C5.01562 26.3628 7.35148 28.6986 10.2295 28.6986C13.1074 28.6986 15.4433 26.3628 15.4433 23.4848C15.4433 20.6069 13.1074 18.271 10.2295 18.271C7.35148 18.271 5.01562 20.6069 5.01562 23.4848Z",
    stroke: "#187C85",
    strokeWidth: 1.25997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_13660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.2354,
    height: 41.9896,
    fill: "white",
    transform: "translate(0.384766 0.508789)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitRiderIcon3);
export default __webpack_public_path__ + "static/media/benefit-rider-icon3.cd46ca070a8123bf11b7c6bf8e3a7586.svg";
export { ForwardRef as ReactComponent };